import { useQuery } from '@tanstack/react-query';
import { IGetFeatureAvailableResponse } from '../types';
import * as featuresService from '../service';

export const useIsAvailableFeatureForCustomer = (
  customerId: string,
  featureName: string
) => {
  const response = useQuery<IGetFeatureAvailableResponse, Error>({
    queryKey: ['feature-available', customerId, featureName],
    queryFn: async () =>
      featuresService.IsFeatureAvailableForCustomer(customerId, featureName),
    enabled: Boolean(customerId && featureName),
  });
  return {
    response,
  };
};
